// @need-translate
import {CommentStatus} from '../../common/shared/api/nicolas/vo/enums/CommentStatus.enum';
import {TextTKey} from '../../common/type';

export const COMMENT_STATE_NAME = 'comment';

export const COMMENT_STATUS_MESSAGE: {[key in CommentStatus]?: TextTKey} = {
  [CommentStatus.Deleted]: {
    text: '작성자가 삭제한 댓글입니다.',
    textTKey: 'comment_user_deleted',
  },
  [CommentStatus.BlockedByAdmin]: {
    text: '운영 정책에 의해 댓글이 삭제되었습니다.',
    textTKey: 'comment_info_deleted_comment_admin',
  },
  [CommentStatus.BlockedByExid]: {
    text: '운영 정책에 의해 댓글이 삭제되었습니다.',
    textTKey: 'comment_info_deleted_comment_admin',
  },
  [CommentStatus.Temp]: {
    text: '권리침해신고에 의해 임시조치되었습니다.',
    textTKey: 'comment_copyright_issue',
  },
  [CommentStatus.DeletedByMe]: {
    text: '내가 삭제한 댓글입니다.',
    textTKey: 'comment_I_deleted',
  },
};
export const REPLY_COMMENT_STATUS_MESSAGE: {[key in CommentStatus]?: string} = {
  [CommentStatus.Deleted]: '작성자가 삭제한 답글입니다.',
  [CommentStatus.BlockedByAdmin]: '운영 정책에 의해 답글이 삭제되었습니다.',
  [CommentStatus.BlockedByExid]: '운영 정책에 의해 답글이 삭제되었습니다.',
  [CommentStatus.Temp]: '권리침해신고에 의해 임시조치되었습니다.',
  [CommentStatus.DeletedByMe]: '내가 삭제한 답글입니다.',
};

export const LOCAL_STORAGE_COMMENT_COOLDOWN = 'comment_cooldown';
export const COMMENT_COOLDOWN_SECONDS = 5;

export const EMPTY_COMMENT_TEXT = '댓글 내역이 없습니다.';
export const EMPTY_COMMENT_CONTENT_HOME_TEXT =
  '작품을 열람하여\n첫 댓글을 남겨주세요!';

export enum CommentTabType {
  All,
  Best,
  My,
}

export const COMMENT_TAB_TEXT_MAP: Record<CommentTabType, TextTKey> = {
  [CommentTabType.All]: {
    text: '전체',
    textTKey: 'comment_all_tabtitle',
  },
  [CommentTabType.Best]: {
    text: 'BEST',
    textTKey: 'comment_badge_best',
  },
  [CommentTabType.My]: {
    text: '내 댓글',
    textTKey: 'comment_accessibility_my',
  },
};
